import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormControlName } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FileForUpload } from "../../models/file.model";
import { UploadService } from "../../services/upload.service";

@Component({
  selector: "up-file",
  templateUrl: "./file.component.html",
  styleUrls: ["./file.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FileComponent {
  isLoading: boolean = false;
  // url: string;

  @ViewChild("fileInput", { static: false }) fileInput: any;
  @ViewChild("menuTrigger") menuTrigger: any;
  @ContentChild(FormControlName) control!: FormControlName;
  @Input() icone = "fal fa-user";
  @Input() label = "Arquivo";
  @Input() value!: FileForUpload;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Input() imageSize: number = 10;

  @Output() uploaded: EventEmitter<boolean> = new EventEmitter();
  @Output() fileRemoved: EventEmitter<boolean> = new EventEmitter();

  //Declarar o array abaixo
  @Input() acceptedFileTypes: string[] = [
    "text/plain",
    "text/css",
    "text/csv",
    "text/html",
    "application/msword",
    "application/json",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/zip",
    "application/x-7z-compressed",
  ];

  isSelectingFile: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private _uploadService: UploadService,
  ) {}

  // Métodos do componente
  changeFile(event: Event): void {
    if (!this.isValid()) {
      this.fileInput.nativeElement.click();
    } else {
      setTimeout(() => {
        this.menuTrigger?.openMenu();
      }, 100);
    }
  }

  openFile(): void {
    this.fileInput.nativeElement.click();
  }

  removeFile(): void {
    this._uploadService.removeFile(this.value.fileId).subscribe({
      next: () => {
        this.value.fileId = "";
        this.value.fileName = "";
        this.value.fileType = "";

        this.fileInput.nativeElement.value = null;

        // Propagar a alteração
        this.propagateChange(this.value);

        this.fileRemoved.emit();
      },
      error: () => {
        this.isLoading = false;
        this._snackBar.open("Erro ao excluir arquivo.");
      },
    });
  }

  addFile(): void {
    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      const fileToUpload = fi.files[0];
      let acceptedFileTypes = this.acceptedFileTypes;

      if (fileToUpload.size > this.imageSize * 1000000) {
        this._snackBar.open(
          `O tamanho da imagem excede o limite de ${this.imageSize} Mb.`,
        );
      } else if (acceptedFileTypes.indexOf(fileToUpload.type) == -1) {
        this._snackBar.open("Formato não suportado.");
      } else {
        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.value.fileName = fileToUpload.name;
          this.value.fileType = fileToUpload.type;

          // Propagar para forçar a recarga do componente
          this.propagateChange(this.value /*'defaultImagePropagate'*/);

          this.isLoading = true;

          this.uploaded.emit(this.isLoading);

          this._uploadService.uploadFile(fileToUpload).subscribe({
            next: (id: string) => {
              this.isLoading = false;
              this.value.fileId = id;

              // Propagar a alteração
              this.propagateChange(this.value);

              this.uploaded.emit(this.isLoading);
            },
            error: () => {
              this.isLoading = false;
              this.uploaded.emit(this.isLoading);

              this.removeFile();
            },
          });
        };
        reader.readAsDataURL(fileToUpload);
      }
    }
  }

  // Métodos do ValueAccessor
  propagateChange = (_: any) => {};

  writeValue(value: any): void {
    this.value = value;
    // this.url = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  // Validação do componente
  isValid(): boolean {
    return this.value != null && this.value.fileId !== "";
  }

  isRequired(): boolean {
    if (this.control) {
      if (!this.control.errors) {
        return false;
      }
      return this.control.errors["required"];
    }
    return false;
  }

  getIcon(): string {
    if (this.value.fileType) {
      if (this.value.fileType.indexOf("pdf") > -1) return "fas fa-file-pdf ";
      else if (
        this.value.fileType.indexOf("html") > -1 ||
        this.value.fileType.indexOf("css") > -1
      )
        return "fas fa-file-code";
      else if (this.value.fileType.indexOf("csv") > -1)
        return "fas fa-file-csv";
      else if (this.value.fileType.indexOf("msword") > -1)
        return "fas fa-file-word";
      else if (this.value.fileType.indexOf("powerpoint") > -1)
        return "fas fa-file-powerpoint";
      else if (
        this.value.fileType.indexOf("zip") > -1 ||
        this.value.fileType.indexOf("7z") > -1
      )
        return "fas fa-file-archive";
      else if (this.acceptedFileTypes.indexOf(this.value.fileType) == 0)
        return this.icone;
      else return "fas fa-file";
    }

    return this.icone;
  }
}
